<app-dialog #wizardDialog title="Erfassungsassistent" dismissLabel="Ohne Vorbelegung starten" acceptLabel="Eingaben in das Formular übernehmen" (accept)="onAccept()">
  <div class="dialog-content">
    <div class="hint-wrapper" style="margin-bottom: 1rem;">
      <div class="hint">
        <mat-icon role="img" class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">info</mat-icon>
        <p>Um die Erfassung zu vereinfachen, können Sie über diesen Assistenten zentrale Informationen der Bekanntmachung vorbelegen. Alle Angaben können Sie im Zuge der Erfassung noch einmal prüfen und bearbeiten.</p>
      </div>
    </div>

    <div class="form-control-container">
      <label>Rechtsgrundlage des Verfahrens</label>
      <app-radio-button
        *ngIf="codeListBt01c?.length > 0"
        [control]="rechtsgrundlageControl"
        [options]="codeListBt01c"
      ></app-radio-button>
    </div>

    <div class="form-control-container">
      <label>Verfahrensart</label>
      <ng-template view></ng-template>
    </div>
  </div>
</app-dialog>
